import React, { useEffect } from 'react';
import { Modal, MessageBoxFunctionalLayout } from '@wix/design-system';
export function CheckAppStatusModal({ checkStatusUrl, closeModal, }) {
    function handleMessage(msg) {
        if (msg.data.type === 'APP_INSTALLATION_FINISHED' ||
            msg.data.type === 'CONSENT_USER_CANCELED' ||
            msg.data.type === 'FINISH_INSTALLATION_EMBEDDED') {
            closeModal();
        }
    }
    useEffect(() => {
        window.addEventListener('message', (msg) => {
            handleMessage(msg);
        });
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageBoxFunctionalLayout, { title: "", theme: "blue", width: "800px", noBodyPadding: true, hideFooter: true, onClose: closeModal },
            React.createElement("iframe", { src: checkStatusUrl, width: "100%", height: "700px", frameBorder: "0" }))));
}
//# sourceMappingURL=check-app-status-modal.js.map